import React from "react";
import ColorInit from "../../../shared/layout/ColorInit";
import Header from "../../../shared/layout/Header";
import LoginSignUp from "../components/LoginSignUp";
import Footer from "../../../shared/layout/Footer";
import BottomFooter from "../../../shared/layout/BottomFooter";
import { CartProvider } from "../../cart/context/CartContext";
import ScrollToTop from "react-scroll-to-top";

const LoginSignUpPage = () => {
    return (
        <CartProvider>
        <ColorInit color={"bigmall"} />

        <ScrollToTop smooth color="#ef253c" />

        <Header />
        <div className="container container-lg">
        <LoginSignUp />
        </div>

        <Footer />

        <BottomFooter />
        </CartProvider>
    );
    };

export default LoginSignUpPage;
